import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/page/home'),
    meta: { 
      keepAlive: true
     }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/page/home'),
    meta: { 
      keepAlive: true
     }
  },
]

export default new VueRouter({
  routes
})
